module.exports = __webpack_public_path__ + "static/media/csdc.6edee029.png";